import { render, staticRenderFns } from "./LoginExt.vue?vue&type=template&id=67a80a86"
import script from "./LoginExt.vue?vue&type=script&lang=js"
export * from "./LoginExt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports